import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import { Button, Grid } from 'material-ui'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  }
})

var minTime = moment()
var maxTime = moment()
var action = ''

@withStyles(styles)
export default class AlchemyToday extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dailyDate: moment().format('l')
    }
    this.nextDay = this.nextDay.bind(this)
    this.prevDay = this.prevDay.bind(this)
    this.setToday = this.setToday.bind(this)
  }

  setToday = () => {
    this.setState({
      dailyDate: moment().format('l')
    })
  }

  timelineSleep = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]
      const sleep = column.pieceData[0]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g
          key={`piece-${key}`}
          cursor={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day')
              ? 'auto'
              : 'pointer'
          }
          onClick={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day') ||
            action === ''
              ? () => {
                  console.log('action to add')
                }
              : () => {
                  sleep.data.type === 'blank'
                    ? action(sleep.data.date, 'add')
                    : action(sleep.data.date, 'other')
                }
          }
        >
          {column.pieceData.map((s, index) => (
            <g key={`stack-rect-${index}`}>
              <rect
                key={`rect-${key}`}
                fill={
                  s.data.trackerId === 1
                    ? 'burlywood'
                    : s.data.trackerId === 2
                      ? 'lightblue'
                      : s.data.trackerId === 5
                        ? 'lightgrey'
                        : s.data.trackerId === 7
                          ? s.data.data.projectTag === 'work'
                            ? 'blue'
                            : s.data.data.projectTag === 'workout'
                              ? 'orange'
                              : s.data.data.projectTag === 'tidyup'
                                ? 'lightgreen'
                                : s.data.data.projectTag === 'internet'
                                  ? 'red'
                                  : s.data.data.projectTag === 'family'
                                    ? 'pink'
                                    : s.data.data.projectTag === 'planning'
                                      ? 'rgba(80, 227, 194, .6)'
                                      : s.data.data.projectTag === 'eat'
                                        ? 'black'
                                        : s.data.data.projectTag === 'chore'
                                          ? 'grey'
                                          : s.data.data.projectTag === 'writing'
                                            ? 'lightseagreen'
                                            : s.data.data.projectTag === 'love'
                                              ? 'magenta'
                                              : 'mediumpurple'
                          : 'grey'
                }
                stroke={''}
                opacity={s.data.trackerId === 1 ? 1 : 0.4}
                width={5}
                height={
                  rScale(new Date(s.data.barEnd)) <
                  rScale(new Date(s.data.barStart))
                    ? rScale(new Date(s.data.barStart)) -
                      rScale(new Date(s.data.barEnd))
                    : 5
                }
                x={
                  s.data.data.isPlan === '1'
                    ? 1
                    : s.data.type === 'dayPlan2_v1'
                      ? 110
                      : s.data.type === 'dayPlan2_v2'
                        ? 90
                        : s.data.type === 'dayPlan2_v3' ? 80 : 160
                }
                y={
                  rScale(maxTime) -
                  rScale(new Date(s.data.barStart)) +
                  rScale(minTime)
                }
                rx={1.5}
                ry={1.5}
              />
              {s.data.type !== 'dayPlan2_v1' &&
                s.data.type !== 'dayPlan2_v2' &&
                s.data.type !== 'dayPlan2_v3' &&
                s.data.trackerId === 5 && (
                  <text
                    key={`piece-text-${key}`}
                    x={170}
                    y={
                      rScale(maxTime) -
                      rScale(new Date(s.data.barStart)) +
                      rScale(minTime) +
                      adjustedSize[0] / 42 +
                      (rScale(new Date(s.data.barStart)) -
                        rScale(new Date(s.data.barEnd))) /
                        2
                    }
                    fontSize={adjustedSize[0] / 30}
                    fill={'lightgrey'}
                  >
                    {s.data.data.hrsDuration}h - {s.data.data.sleepScore}%
                  </text>
                )}
              {s.data.type !== 'dayPlan2_v1' &&
                s.data.type !== 'dayPlan2_v2' &&
                s.data.type !== 'dayPlan2_v3' &&
                s.data.trackerId === 1 && (
                  <text
                    key={`piece-text-${key}`}
                    x={170}
                    y={
                      rScale(maxTime) -
                      rScale(new Date(s.data.barStart)) +
                      rScale(minTime) +
                      adjustedSize[0] / 42
                    }
                    fontSize={adjustedSize[0] / 30}
                    fill={'lightgrey'}
                  >
                    {s.data.data.weightLB} lb
                  </text>
                )}
              {s.data.type !== 'dayPlan2_v1' &&
                s.data.type !== 'dayPlan2_v2' &&
                s.data.type !== 'dayPlan2_v3' &&
                s.data.trackerId === 2 && (
                  <text
                    key={`piece-text-${key}`}
                    x={170}
                    y={
                      rScale(maxTime) -
                      rScale(new Date(s.data.barStart)) +
                      rScale(minTime) +
                      adjustedSize[0] / 42 +
                      (rScale(new Date(s.data.barStart)) -
                        rScale(new Date(s.data.barEnd))) /
                        2
                    }
                    fontSize={adjustedSize[0] / 30}
                    fill={'lightgrey'}
                  >
                    {s.data.data.pages} pages - {s.data.data.durationMin}m |{' '}
                    {s.data.data.bookName}
                  </text>
                )}
              {s.data.type !== 'dayPlan2_v1' &&
                s.data.type !== 'dayPlan2_v2' &&
                s.data.type !== 'dayPlan2_v3' &&
                s.data.trackerId === 7 && (
                  <text
                    key={`piece-text-${key}`}
                    x={s.data.data.isPlan === '1' ? 8 : 170}
                    y={
                      rScale(maxTime) -
                      rScale(new Date(s.data.barStart)) +
                      rScale(minTime) +
                      adjustedSize[0] / 42 +
                      (rScale(new Date(s.data.barStart)) -
                        rScale(new Date(s.data.barEnd))) /
                        2
                    }
                    fontSize={adjustedSize[0] / 30}
                    fill={'lightgrey'}
                  >
                    {s.data.data.durationMin}m |
                    {s.data.data.issueName}
                  </text>
                )}
              {new Date(s.data.barEnd) <=
                moment(moment(new Date(this.state.dailyDate)))
                  .hour('7')
                  .minute('0')
                  .second('0') && s.data.type !== 'blank' ? (
                <text
                  key={`piece-${key}`}
                  x={column.x + column.width / 2 - adjustedSize[0] / 64}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime) +
                    adjustedSize[0] / 22
                  }
                  fontSize={adjustedSize[0] / 30}
                  fill={'white'}
                >
                  ★
                </text>
              ) : (
                <text key={`text-${key}`} />
              )}
            </g>
          ))}
        </g>
      )

      renderedPieces.push(markObject)
    })

    return renderedPieces
  }

  prevDay = () => {
    const prevDayNo = moment(new Date(this.state.dailyDate)).subtract(1, 'day')
    this.setState({
      dailyDate: prevDayNo.format('l')
    })
  }

  nextDay = () => {
    const nextDayNo = moment(new Date(this.state.dailyDate)).add(1, 'day')
    this.setState({
      dailyDate: nextDayNo.format('l')
    })
  }

  render() {
    const { classes } = this.props
    const tmp = this.props.data

    const dataSleepWeekly = tmp.filter(
      sleep =>
        moment(new Date(sleep.date)).format('l') ===
        moment(new Date(this.state.dailyDate)).format('l')
    )
    var dataChartSleepWeekly = []
    const sleepDays = dataSleepWeekly.length

    for (var i = 0; i < sleepDays; i++) {
      const sleepDurationMin = moment(
        new Date(dataSleepWeekly[i].timeComplete),
        'MM/DD/YYYY HH:mm'
      ).diff(
        moment(new Date(dataSleepWeekly[i].timeStart), 'MM/DD/YYYY HH:mm'),
        'minutes'
      )

      const barEndTime = moment(
        new Date(dataSleepWeekly[i].timeComplete)
      ).format('MM/DD/YYYY HH:mm')

      dataChartSleepWeekly.splice(
        moment(new Date(dataSleepWeekly[i].date)).day(),
        0,
        {
          date: moment(new Date(dataSleepWeekly[i].date)).format('l'),
          barStart: moment(new Date(barEndTime))
            .subtract(sleepDurationMin, 'minute')
            .format('MM/DD/YYYY HH:mm'),
          barEnd: barEndTime,
          type: dataSleepWeekly[i].type,
          trackerId: dataSleepWeekly[i].trackerId,
          trackerName: dataSleepWeekly[i].trackerName,
          data: dataSleepWeekly[i]
        }
      )
    }

    dataChartSleepWeekly.push(
      {
        date: this.state.dailyDate,
        barStart: moment(
          new Date(
            moment(new Date(this.state.dailyDate))
              .subtract(1, 'day')
              .format('l') + ' 22:30'
          )
        ).format('MM/DD/YYYY HH:mm'),
        barEnd: moment(new Date(this.state.dailyDate + ' 05:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 5,
        trackerName: 'sleep',
        data: ''
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 05:40')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 06:20')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 2,
        trackerName: 'reading',
        data: ''
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 15:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 18:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: {
          projectTag: 'workout'
        }
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 06:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 10:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: ''
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 11:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 12:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: {
          projectTag: 'chore'
        }
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 12:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 13:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: {
          projectTag: 'planning'
        }
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 13:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 15:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: ''
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 20:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 21:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: ''
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 10:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 11:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: {
          projectTag: 'eat'
        }
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 18:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 20:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: {
          projectTag: 'eat'
        }
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 21:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 21:45')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 7,
        trackerName: 'project',
        data: {
          projectTag: 'workout'
        }
      },
      {
        date: this.state.dailyDate,
        barStart: moment(new Date(this.state.dailyDate + ' 21:45')).format(
          'MM/DD/YYYY HH:mm'
        ),
        barEnd: moment(new Date(this.state.dailyDate + ' 22:30')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 2,
        trackerName: 'reading',
        data: ''
      },
      {
        date: this.state.dailyDate,
        barStart: moment(
          new Date(
            moment(new Date(this.state.dailyDate)).format('l') + ' 22:30'
          )
        ).format('MM/DD/YYYY HH:mm'),
        barEnd: moment(new Date(this.state.dailyDate + ' 23:00')).format(
          'MM/DD/YYYY HH:mm'
        ),
        type: 'dayPlan2_v1',
        trackerId: 5,
        trackerName: 'sleep',
        data: ''
      }
    )

    var sleepStartTimes = []
    var sleepEndTimes = []

    dataChartSleepWeekly.forEach(s => {
      sleepStartTimes.push(moment(new Date(s.barStart)))
      sleepEndTimes.push(moment(new Date(s.barEnd)))
    })

    minTime = moment.min(sleepStartTimes).subtract(1, 'hour')
    maxTime = moment.max(sleepEndTimes).add(1, 'hour')

    if (this.props.action) {
      action = this.props.action
    } else {
      action = ''
    }

    //daily top activities
    var dataSleepWeeklyNonProject = dataSleepWeekly.filter(
      e =>
        e.trackerName !== 'project' &&
        e.trackerName !== 'body weight' &&
        e.trackerName !== 'sleep'
    )

    var result = {}
    for (i = 0; i < dataSleepWeeklyNonProject.length; i++) {
      if (!result[dataSleepWeeklyNonProject[i]['trackerName']]) {
        result[dataSleepWeeklyNonProject[i]['trackerName']] = 0
      }
      if (
        dataSleepWeeklyNonProject[i] &&
        dataSleepWeeklyNonProject[i]['durationMin'] > 0
      ) {
        result[dataSleepWeeklyNonProject[i]['trackerName']] += parseInt(
          dataSleepWeeklyNonProject[i]['durationMin'],
          10
        )
      }
    }

    //daily top activities
    var dataSleepWeeklySleep = dataSleepWeekly.filter(
      e => e.trackerName === 'sleep'
    )

    var resultSleep = {}
    for (i = 0; i < dataSleepWeeklySleep.length; i++) {
      if (!resultSleep[dataSleepWeeklySleep[i]['trackerName']]) {
        resultSleep[dataSleepWeeklySleep[i]['trackerName']] = 0
      }
      if (
        dataSleepWeeklySleep[i] &&
        dataSleepWeeklySleep[i]['hrsDuration'] > 0
      ) {
        resultSleep[dataSleepWeeklySleep[i]['trackerName']] += parseInt(
          dataSleepWeeklySleep[i]['hrsDuration'] * 60,
          10
        )
      }
    }

    var resultJSON = Object.keys(result).map(key => {
      return {
        type: key,
        mins: parseInt(result[key], 10)
      }
    })

    var dataSleepWeeklyProject = dataSleepWeekly.filter(
      e => e.trackerName === 'project' && (e.isPlan ? e.isPlan !== '1' : true)
    )

    var resultProject = {}
    for (i = 0; i < dataSleepWeeklyProject.length; i++) {
      if (!resultProject[dataSleepWeeklyProject[i]['projectTag']]) {
        resultProject[dataSleepWeeklyProject[i]['projectTag']] = 0
      }
      if (
        dataSleepWeeklyProject[i] &&
        dataSleepWeeklyProject[i]['durationMin'] > 0
      ) {
        resultProject[dataSleepWeeklyProject[i]['projectTag']] += parseInt(
          dataSleepWeeklyProject[i]['durationMin'],
          10
        )
      }
    }

    Object.keys(resultProject).forEach(key => {
      resultJSON.push({
        type: key,
        mins: parseInt(resultProject[key], 10)
      })
    })

    resultJSON.sort(function(a, b) {
      return new Date(b.mins) - new Date(a.mins)
    })

    var offTrackMins =
      24 * 60 -
      resultJSON.reduce(function(cnt, o) {
        return cnt + o.mins
      }, 0)

    if (resultSleep && resultSleep.sleep > 0) {
      offTrackMins -= resultSleep.sleep
    }

    if (offTrackMins > 0) {
      resultJSON.push({
        type: 'no tracking',
        mins: offTrackMins
      })
    }

    Object.keys(resultSleep).forEach(key => {
      resultJSON.push({
        type: key,
        mins: parseInt(resultSleep[key], 10)
      })
    })

    return (
      <div>
        <div
          id="switch-weeks"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevDay()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 14 }}>
                {moment(new Date(this.state.dailyDate)).format('M/D ddd')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextDay()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment(new Date(this.state.dailyDate)).format('l') ===
              moment().format('l') ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div
          id="daily_sleep_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <div className={classes.divChartBurnDown}>
            <OrdinalFrame
              size={[this.props.width / 1.28, this.props.height / 1.28]}
              data={dataChartSleepWeekly}
              rAccessor={d => new Date(d.barStart)}
              oAccessor={d => new Date(d.date)}
              //sortO={(a, b) => a > b}
              rExtent={[minTime, maxTime]}
              type={{
                type: this.timelineSleep
              }}
              invertR={true}
              oPadding={this.props.width / 35}
              axis={[
                {
                  orient: 'left',
                  ticks: 12,
                  tickFormat: d => (
                    <text
                      key={`tick-${d}`}
                      style={{
                        fill: '#cecece',
                        textAnchor: 'end',
                        fontSize: 10
                      }}
                      y={-2}
                      x={
                        moment(new Date(d)).format('h') === '12'
                          ? 164
                          : moment(new Date(d)).seconds() === 0 ? 150 : 157
                      }
                    >
                      {moment(new Date(d)).format('h') === '12'
                        ? moment(new Date(d)).format('h a')
                        : moment(new Date(d)).seconds() === 0
                          ? moment(new Date(d)).format('h')
                          : moment(new Date(d)).format('h:ss')}
                    </text>
                  ),
                  tickValues: [
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('0')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('2')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('4')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('6')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('8')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('10')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('12')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('14')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('16')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('18')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('20')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('22')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .subtract(1, 'day')
                        .hour('22')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('1')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('3')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('5')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('7')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('9')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('11')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('13')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('15')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('17')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('19')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('21')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .hour('23')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(moment(new Date(this.state.dailyDate)))
                        .subtract(1, 'day')
                        .hour('23')
                        .minute('0')
                        .second('0')
                    ),
                    this.state.dailyDate !== moment().format('l')
                      ? ''
                      : new Date(
                          moment(moment(new Date(this.state.dailyDate)))
                            .hour(moment().hour())
                            .minute(moment().minutes())
                            .second(moment().seconds())
                        )
                  ],
                  baseline: false,
                  tickLineGenerator: ({ xy }) => (
                    <path
                      key={`tickLine-${xy.value}`}
                      style={{
                        stroke:
                          moment(new Date(xy.value)).seconds() !== 0
                            ? 'rgba(255,192,203,.3)'
                            : 'rgba(0,0,0,.02) '
                      }}
                      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                        xy.y1
                      }L${xy.x1},${xy.y1}Z`}
                    />
                  )
                }
              ]}
              margin={{
                left: this.props.width / 7.5,
                top: this.props.height / 24,
                right: this.props.width / 10.6,
                bottom: this.props.height / 9.6
              }}
              annotationSettings={{
                layout: {
                  type: 'marginalia',
                  orient: 'right',
                  textPadding: this.props.width / 21
                }
              }}
              hoverAnnotation={false}
              tooltipContent={d => (
                <div
                  key={`tooltip-${d.summary[0].renderKey}`}
                  className={classes.tooltipContent}
                >
                  <p key={`p-1`}>
                    {moment(new Date(d.pieces[0].date)).format('MM/DD/YYYY')}
                  </p>
                  <p key={`p-2`}>
                    Slept{' '}
                    {moment
                      .utc(
                        moment(
                          new Date(d.pieces[0].barEnd),
                          'MM/DD/YYYY HH:mm'
                        ).diff(
                          moment(
                            new Date(d.pieces[0].barStart),
                            'MM/DD/YYYY HH:mm'
                          )
                        )
                      )
                      .format('HH:mm')}:
                  </p>
                  <p key={`p-3`}>
                    - Slept at{' '}
                    {moment(new Date(d.pieces[0].barStart)).format('HH:mm A')}
                  </p>
                  <p key={`p-4`}>
                    - Got up at{' '}
                    {moment(new Date(d.pieces[0].barEnd)).format('HH:mm A')}
                  </p>
                </div>
              )}
            />
          </div>
        </div>
        <div
          id="switch-weeks"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevDay()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 14 }}>
                {moment(new Date(this.state.dailyDate)).format('M/D ddd')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextDay()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment(new Date(this.state.dailyDate)).format('l') ===
              moment().format('l') ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div className={classes.divChartBurnDown}>
          <OrdinalFrame
            /* --- Data --- */
            data={resultJSON}
            /* --- Size --- */
            size={[350, 350]}
            margin={50}
            /* --- Layout --- */
            type="bar"
            projection="radial"
            dynamicColumnWidth={d => d[0] && d[0].mins > 0 && d[0].mins}
            /* --- Process --- */
            oAccessor="type"
            /* --- Customize --- */
            style={d => ({
              fill:
                d.type === 'body weight'
                  ? 'burlywood'
                  : d.type === 'reading'
                    ? 'lightblue'
                    : d.type === 'sleep'
                      ? 'lightgrey'
                      : d.type === 'work'
                        ? 'blue'
                        : d.type === 'workout'
                          ? 'orange'
                          : d.type === 'tidyup'
                            ? 'lightgreen'
                            : d.type === 'internet'
                              ? 'red'
                              : d.type === 'family'
                                ? 'pink'
                                : d.type === 'planning'
                                  ? 'rgba(80, 227, 194, .6)'
                                  : d.type === 'eat'
                                    ? 'black'
                                    : d.type === 'chore'
                                      ? 'grey'
                                      : d.type === 'writing'
                                        ? 'lightseagreen'
                                        : d.type === 'love'
                                          ? 'magenta'
                                          : d.type === 'no tracking'
                                            ? 'white'
                                            : 'mediumpurple',
              stroke: d.type === 'no tracking' ? 'lightgrey' : 'white'
            })}
            title="What good have I done to-day?"
            /* --- Annotate --- */
            oLabel={true}
          />
        </div>
        <div
          style={{
            textAlign: 'left',
            marginLeft: 100,
            marginTop: -30,
            marginBottom: 20
          }}
        >
          {resultJSON.map(r => (
            <span
              key={r.type}
              style={{
                color:
                  r.type === 'body weight'
                    ? 'burlywood'
                    : r.type === 'reading'
                      ? 'lightblue'
                      : r.type === 'sleep'
                        ? 'lightgrey'
                        : r.type === 'work'
                          ? 'blue'
                          : r.type === 'workout'
                            ? 'orange'
                            : r.type === 'tidyup'
                              ? 'lightgreen'
                              : r.type === 'internet'
                                ? 'red'
                                : r.type === 'family'
                                  ? 'pink'
                                  : r.type === 'planning'
                                    ? 'rgba(80, 227, 194, .6)'
                                    : r.type === 'eat'
                                      ? 'black'
                                      : r.type === 'chore'
                                        ? 'grey'
                                        : r.type === 'writing'
                                          ? 'lightseagreen'
                                          : r.type === 'love'
                                            ? 'magenta'
                                            : r.type === 'no tracking'
                                              ? 'silver'
                                              : 'mediumpurple'
              }}
            >
              {r.type}:{' '}
              {parseInt(r.mins, 10) < 60
                ? parseInt(r.mins, 10) + ' mins'
                : parseInt(r.mins, 10) % 60 === 0
                  ? Math.floor(parseInt(r.mins, 10) / 60).toFixed(0) + ' hrs'
                  : Math.floor(parseInt(r.mins, 10) / 60).toFixed(0) +
                    ' hrs ' +
                    parseInt(r.mins, 10) % 60 +
                    ' mins'}{' '}
              <br />
            </span>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyToday.js